// extracted by mini-css-extract-plugin
export default {"spinner-content":"IpaAdministrationWizard_spinner-content__z1ocJ","spinner":"IpaAdministrationWizard_spinner__dOxMN"};